<template>
  <div class="page-content text-center" style="padding-top: 4rem">
    <div class="warning-gradient card p-4">
      <h5 class="text-white fw-bold">SETTLEMENT DETAILS</h5>
    </div>
    <div class="container-fluid d-flex gap-4">
      <div
        class="card flex-1 d-flex flex-column justify-content-between rounded"
      >
        <div class="mt-4 rounded-top">
          <h6 class="fw-bold">BANK DETAILS</h6>
        </div>
        <div class="row text-start px-3 py-2">
          <div class="col-lg-12 mb-3">
            <div>
              <label class="form-label"
                >Bank ID<span style="color: red">*</span></label
              >
              <input
                v-model="bank.id"
                class="form-control"
                placeholder="Enter Bank Name"
                disabled
              />
            </div>
          </div>
          <div class="col-lg-12 mb-3">
            <div>
              <label class="form-label"
                >Bank Name<span style="color: red">*</span></label
              >
              <input
                v-model="bank.name"
                @input="v$.bank.name.$touch()"
                class="form-control"
                placeholder="Enter Bank Name"
                :disabled="!isEditBankDetails"
              />
              <div class="error-message text-danger">
                <span v-if="v$.bank.name.$errors.length">
                  {{ v$.bank.name.$errors[0].$message }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-12 mb-3">
            <div>
              <label for="name" class="form-label"
                >Account Number<span style="color: red">*</span></label
              >
              <input
                v-model="bank.accountNumber"
                @input="v$.bank.accountNumber.$touch()"
                class="form-control"
                placeholder="Enter Account Number"
                :disabled="!isEditBankDetails"
              />
              <div class="error-message text-danger">
                <span v-if="v$.bank.accountNumber.$errors.length">
                  {{ v$.bank.accountNumber.$errors[0].$message }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-12 mb-3">
            <div>
              <label for="name" class="form-label"
                >IFSC Code <span style="color: red">*</span></label
              >
              <input
                v-model="bank.IFSCCode"
                @input="v$.bank.IFSCCode.$touch()"
                class="form-control"
                placeholder="Enter IFSC Code"
                :disabled="!isEditBankDetails"
              />
              <div class="error-message text-danger">
                <span v-if="v$.bank.IFSCCode.$errors.length">
                  {{ v$.bank.IFSCCode.$errors[0].$message }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-end pb-2">
          <button class="btn fs-6 text-muted fw-bold" @click="handleCancel">
            CANCEL
          </button>
          <button
            class="btn fs-6 text-warning fw-bold"
            @click="updateBankDetails"
          >
            <div
              v-if="loading"
              class="spinner-border spinner-border-sm"
              role="status"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
            <span v-else> {{ !isEditBankDetails ? "EDIT" : "SAVE" }} </span>
          </button>
        </div>
      </div>
      <div
        class="card flex-1 d-flex flex-column justify-content-between rounded"
      >
        <div class="mb-1 p-3 rounded-top">
          <h6 class="mt-2 fw-bold">OPERATOR DETAILS</h6>
        </div>
        <div class="row text-start px-3 py-1">
          <div class="col-lg-12 mb-2">
            <div>
              <label for="name" class="form-label"
                >Operator ID<span style="color: red">*</span></label
              >
              <input class="form-control" v-model="operator.id" disabled />
            </div>
          </div>
          <div class="col-lg-12 mb-3">
            <div>
              <label for="name" class="form-label"
                >Operator Name<span style="color: red">*</span></label
              >
              <input class="form-control" v-model="operator.name" disabled />
            </div>
          </div>
          <div class="col-lg-12 mb-3">
            <div>
              <label for="name" class="form-label"
                >Operator Number <span style="color: red">*</span></label
              >
              <input
                class="form-control"
                v-model="operator.phoneNumber"
                disabled
              />
            </div>
          </div>
          <div class="col-lg-12 mb-3">
            <div>
              <label for="name" class="form-label"
                >Bus No<span style="color: red">*</span></label
              >
              <input class="form-control" v-model="bus.number" disabled />
            </div>
          </div>
          <div class="col-lg-12 mb-3">
            <div>
              <label class="form-label"
                >Travels Name<span style="color: red">*</span></label
              >
              <input class="form-control" disabled v-model="bus.name" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card px-4">
      <div class="my-4 rounded-top">
        <h6 class="fw-bold">FARE DISTRIBUTION</h6>
      </div>
      <div class="table-responsive table-card">
        <rb-data-table
          :ldata="ldata"
          :headers="headers"
          :tableData="formattedFares"
          :editBtn="false"
          :deleteBtn="false"
        />
      </div>
    </div>
    <div
      class="d-flex gap-5 mb-5 mt-3 p-4 align-items-center rounded"
      style="background-color: white"
    >
      <div style="width: 50%" class="p-5">
        <img src="/images/logo_main.png" width="250px" />
        <div class="d-flex align-items-start mt-4">
          <p class="text-muted">
            Before submitting the form, please take a moment to carefully review
            all the information you’ve entered. Ensure that your bank details,
            account numbers, and personal data are accurate and complete.
            Incorrect information may lead to processing delays or failed
            settlements.
          </p>
        </div>
      </div>
      <div
        class="d-flex flex-column justify-content-center rounded"
        style="width: 50%"
      >
        <div class="row text-start px-3 py-3">
          <div class="col-lg-12 mb-3">
            <div>
              <label for="name" class="form-label"
                >Amount Paid <span style="color: red">*</span></label
              >
              <input class="form-control" v-model="amount" disabled />
            </div>
          </div>
          <div class="col-lg-12 mb-2">
            <div>
              <label for="remark" class="form-label"
                >Remark <span style="color: red">*</span></label
              >
              <textarea
                id="remark"
                class="form-control"
                v-model="remark"
                rows="4"
                disabled
              ></textarea>
            </div>
          </div>
          <div class="col-lg-12 mb-2">
            <div>
              <label for="name" class="form-label"
                >Transaction ID <span style="color: red">*</span></label
              >
              <input
                class="form-control"
                v-model="transactionID"
                @input="v$.transactionID.$touch()"
              />
              <div class="error-message text-danger">
                <span v-if="v$.transactionID.$errors.length">
                  {{ v$.transactionID.$errors[0].$message }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-12 mb-2">
            <div>
              <label for="name" class="form-label"
                >Bank Reference No <span style="color: red">*</span></label
              >
              <input
                class="form-control"
                v-model="referenceNumber"
                @input="v$.referenceNumber.$touch()"
              />
              <div class="error-message text-danger">
                <span v-if="v$.referenceNumber.$errors.length">
                  {{ v$.referenceNumber.$errors[0].$message }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-12 mb-2">
            <div>
              <label for="name" class="form-label"
                >Status <span style="color: red">*</span></label
              >
              <select
                class="form-control"
                v-model="status"
                @input="v$.status.$touch()"
                :disabled="status === 'settled'"
              >
                <option value="settled">Settled</option>
                <option value="pending">Pending</option>
              </select>
              <div class="error-message text-danger">
                <span v-if="v$.status.$errors.length">
                  {{ v$.status.$errors[0].$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-lg-12 my-4">
            <div>
              <button
                :disabled="
                  v$.referenceNumber.$invalid || v$.transactionID.$invalid
                "
                :class="[
                  'btn',
                  'w-100',
                  'btn-warning',
                  'button',
                  {
                    'btn-disabled':
                      v$.referenceNumber.$invalid || v$.transactionID.$invalid,
                  },
                ]"
                @click="submit"
              >
                <div
                  v-if="loading"
                  class="spinner-border spinner-border-sm"
                  role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
                <span v-else>SUBMIT</span>
              </button>
            </div>
          </div>
        </div>
        <ToastNotification ref="toast" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useUserStore } from "@/store/user";
import { useAuthStore } from "@/store/auth";
import { addSettlements, updateSettlements } from "@/apis/settlement";
import { updateBank } from "@/apis/bank";
import useVuelidate from "@vuelidate/core";
import { required, helpers, numeric } from "@vuelidate/validators";
import { settlementFareDistributionHeaders } from "@/constants/headers";

export default {
  name: "settlementPage",
  data() {
    return {
      operator: {
        id: null,
        name: null,
        phoneNumber: null,
      },

      bus: {
        id: null,
        name: null,
        number: null,
      },

      bank: {
        id: null,
        name: null,
        accountNumber: null,
        IFSCCode: null,
      },

      bookingDetails: [],

      isEditBankDetails: false,

      transactionID: null,
      referenceNumber: null,
      settlementID: null,
      status: null,
      createdBy: null,

      loading: false,
      v$: null,

      headers: settlementFareDistributionHeaders,
    };
  },
  methods: {
    ...mapActions(useUserStore, ["getEditData", "clearEditData"]),

    async submit() {
      this.loading = true;

      let res;

      if (this.status === "settled") {
        res = await this.updateSettlements();
      } else {
        res = await this.addSettlements();
      }

      if (res.success) {
        this.$refs.toast.showToast(
          "Settlements Updated Succesfully !",
          "success"
        );
      } else {
        this.$refs.toast.showToast("Failed to Update Settlemenst !", "error");
      }

      setTimeout(() => {
        this.$router.push("/settlements");
      }, 3000);

      this.loading = false;
    },

    async updateSettlements() {
      const response = await updateSettlements(
        {
          bank_reference_number: this.referenceNumber,
          transaction_id: this.transactionID,
        },
        this.settlementID
      );

      return response;
    },

    async addSettlements() {
      const payload = {
        operator_id: this.operator.id,
        operator_name: this.operator.name,
        operator_phone_number: this.operator.phoneNumber,
        remark: this.remark,
        bus_id: this.bus.id,
        bus_travels_name: this.bus.name,
        bus_number: this.bus.number,
        bank_name: this.bank.name,
        account_number: this.bank.accountNumber,
        ifsc_code: this.bank.IFSCCode,
        amount: this.amount,
        transaction_id: this.transactionID,
        bank_reference_number: this.referenceNumber,
        created_by: this.ldata.admin_id,
        settled_status: this.status,
      };

      const response = await addSettlements(payload);
      return response;
    },

    handleCancel() {
      if (this.isBankFormDirty) {
        if (
          confirm("You have unsaved changes. Are you sure you want to cancel?")
        ) {
          this.resetBankForm();
          this.isEditBankDetails = false;
        }
      } else {
        this.isEditBankDetails = false;
      }
    },

    resetBankForm() {
      this.bank.name = this.userEditData.bank_name;
      this.bank.accountNumber = this.userEditData.account_number;
      this.bank.IFSCCode = this.userEditData.ifsc_code;
      this.v$.$reset();
    },

    async updateBankDetails() {
      if (!this.isEditBankDetails) {
        this.isEditBankDetails = true;
        return;
      }

      this.loading = true;

      const response = await updateBank(
        this.bank.id,
        this.bank.name,
        this.bank.accountNumber,
        this.bank.IFSCCode
      );
      if (response.success) {
        this.$refs.toast.showToast(
          "Succesfully Bank Details Updated !",
          "success"
        );
      } else {
        this.$refs.toast.showToast("Failed to Update Bank Details", "error");
      }

      this.isEditBankDetails = false;
      this.v$.$reset();
      this.loading = false;
    },
  },
  mounted() {
    this.getEditData();

    console.log(this.userEditData, "this.userEditData");

    if (this.userEditData) {
      const {
        bus_id,
        operator_id,
        phone_number,
        operator_name,
        reg_no,
        account_number,
        bank_name,
        travels_name,
        ifsc_code,
        amount,
        transaction_id,
        bank_reference_number,
        settled_status,
        remark,
        settlement_id,
        bank,
        booking_details,
      } = this.userEditData;

      this.settlementID = settlement_id;
      this.bookingDetails = booking_details;

      this.operator.name = operator_name;
      this.operator.id = operator_id;
      this.operator.phoneNumber = phone_number;

      this.bus.id = bus_id;
      this.bus.name = travels_name;
      this.bus.number = reg_no;

      this.bank.accountNumber = account_number;
      this.bank.name = bank_name;
      this.bank.IFSCCode = ifsc_code;
      this.bank.id = bank.bank_id;

      this.amount = amount;
      this.transactionID = transaction_id;
      this.referenceNumber = bank_reference_number;
      this.status = settled_status;
      this.remark = remark;
    }
  },

  created() {
    this.v$ = useVuelidate(this.$options.validations, this);
  },

  validations: {
    bank: {
      name: { required },
      accountNumber: { required, numeric },
      IFSCCode: {
        required: helpers.withMessage("IFSC code is required", required),
        ifscValidation: helpers.withMessage(
          "Invalid IFSC format (e.g., SBIN0001234)",
          (value) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)
        ),
      },
    },
    transactionID: { required },
    referenceNumber: { required },
    status: { required },
  },

  computed: {
    ...mapState(useUserStore, ["userEditData"]),
    ...mapState(useAuthStore, ["ldata"]),

    isBankFormDirty() {
      return (
        this.bank.name !== this.userEditData.bank_name ||
        this.bank.accountNumber !== this.userEditData.account_number ||
        this.bank.IFSCCode !== this.userEditData.ifsc_code
      );
    },

    formattedFares() {
      return this.bookingDetails.map((booking) => ({
        bookingID: booking.booking_id,
        totalPassengers: booking.total_passengers,
        luggageFare: booking.luggage_fare,
        routeBusFee: booking.route_bus_fee || 0,
        totalAmount: booking.total_fare || 0,
        walletPointsUsed: booking.wallet_points_used || 0,
        discountedPrice: booking.discounted_price || 0,
        finalFare: booking.final_fare || 0,
        bookingStatus: booking.booking_status,
        status: booking.payment_status,
      }));
    },
  },
};
</script>

<style scoped>
.warning-gradient {
  background: linear-gradient(135deg, #ffc107, #ffa115);
  color: white;
}
</style>
